<script lang="ts">

  import Loader from "$lib/components/loader.svelte"
  import { Button } from "$lib/components/ui/button"
  import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "$lib/components/ui/sheet"
  import { useDialog } from "$lib/hooks/use-dialog.svelte"
  import DownloadIcon from "@lucide/svelte/icons/download"
  import XIcon from "@lucide/svelte/icons/x"
  import { createQuery } from "@tanstack/svelte-query"

  type Data = {
    url: string
    filename: string
  }

  const dialog = useDialog()
  let data = $state<Data>({ url: "", filename: "" })

  const query = createQuery(() => ({
    enabled: !!data.url,
    queryKey: ["viewer-log", {
      data
    }],
    queryFn: async () => {
      const response = await fetch(data.url)
      return response.text()
    }
  }))

  function handleDownload() {
    const blob = new Blob([query.data || ""], { type: "text/plain;charset=utf-8" })
    blob.download(data.filename)
  }


  $effect(() => {

    function handleView(event: CustomEvent) {
      data = event.detail as Data
      dialog.setOpen(true)
    }

    window.addEventListener("view-log", handleView as EventListener)
    return () => {
      window.removeEventListener("view-log", handleView as EventListener)
    }
  })

  $effect(() => {
    if (dialog.state) return
    try {
      URL.revokeObjectURL(data.url)
    } catch {
    }
  })

</script>
<Sheet
  open={dialog.state}
  onOpenChange={dialog.setOpen}
  onOpenChangeComplete={() => ""}>
  <SheetContent
    class="h-full! w-full! z-60 p-0 border-none data-[state=open]:duration-0"
    side="bottom"
    showCloseButton={false}>
    <SheetHeader class="hidden">
      <SheetTitle>View Log</SheetTitle>
      <SheetDescription></SheetDescription>
    </SheetHeader>
    <div class="flex h-full flex-col">
      <nav class="sticky w-full top-0 border-b bg-background">
        <div class="flex h-12 items-center justify-between px-3">
          <div class="flex items-center gap-2">
            <Button variant="ghost"
                    size="icon"
                    class="rounded-full"
                    onclick={() => dialog.setOpen(false)}>
              <XIcon/>
            </Button>
            <h1 class="text-lg font-medium">
              Lihat Log
            </h1>
          </div>
          <div>
            <Button variant="ghost"
                    size="icon"
                    class="rounded-full"
                    onclick={handleDownload}>
              <DownloadIcon/>
            </Button>
          </div>
        </div>
      </nav>
      <div class="relative flex-1 overflow-auto p-2 bg-muted/50">
        <Loader show={query.isFetching}/>
        <pre class="font-mono text-sm whitespace-pre-wrap break-all">{query.data || ""}</pre>
      </div>
    </div>
  </SheetContent>
</Sheet>
